import { AxiosError } from 'axios';
import { FC } from 'react';
import { showToast } from '../../../../components/Toast/Toast';
import { ToastTypes } from '../../../../components/Toast/Toast.types';
import { MENU_FILTERS } from '../../../../constants/ApiEnums';
import { useActivateMenu } from '../../../../services/extract/extract.service';
import { Organization } from '../../../../services/menu/menu.types';
import { genericErrorShowToastOptions } from '../../../../utils/useGenericErrorMessage/useGenericErrorMessage';
import useNavigateWithToast from '../../../../utils/useNavigateWithToast/useNavigateWithToast';
import SelectMenus from '../SelectMenus/SelectMenus';

const ActivateMenu: FC = () => {
  const navigateWithToast = useNavigateWithToast();
  const { mutate, isLoading } = useActivateMenu();

  const handleClick = (selectedMenus: Organization[]) => {
    mutate(
      selectedMenus.map((menu) => ({ menuNo: +menu.id, menuId: menu.additionalProperties.menuId })),
      {
        onSuccess: () => {
          navigateWithToast('/extract', {
            label: 'Menu activations have been submitted. Please allow up to an hour for status to process.',
            id: 'menuActivateSuccess',
          });
        },
        onError: (error) => {
          if ((error as AxiosError).message === 'apiGatewayTimeout') {
            navigateWithToast('/extract', {
              label: 'The request is taking longer than usual to process.',
              subtext: 'Please check back later to see if your changes have been applied.',
              id: 'apiGatewayTimeout',
              toastType: ToastTypes.Error,
            });
            return;
          }
          showToast({
            ...genericErrorShowToastOptions,
            label: 'Error activating menus.',
            id: 'menuActivateError',
            toastType: ToastTypes.Error,
          });
        },
      }
    );
  };

  return <SelectMenus activateOrExtract={MENU_FILTERS.ACTIVATE} onClick={handleClick} isLoading={isLoading} />;
};

export default ActivateMenu;
